import React, { useEffect, useState } from "react";
import axios from "axios";

const BASE_URL = "https://ecom.cyberathon.com";
const API_URL = BASE_URL + "/index.php/Hijama/list_why_us";

function Aboutwhyus1() {
  const [whyUsData, setWhyUsData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWhyUs = async () => {
      try {
        const res = await axios.get(API_URL);

        if (res.data.status === true && res.data.data.length > 0) {
          setWhyUsData(res.data.data[0]); // only first record
        }

        setLoading(false);
      } catch (error) {
        console.error("Error loading WhyUs:", error);
        setLoading(false);
      }
    };

    fetchWhyUs();
  }, []);

  if (loading) return <p className="text-center py-5">Loading...</p>;

  if (!whyUsData)
    return <p className="text-center py-5">No Data Found!</p>;

  return (
    <div className="container-fluid bg-light px-5 py-5">
      <div className="row">
        
        {/* Heading Section */}
        <div className="col-12 col-md-4">
          <h2 className="text-dark fw-bold mb-4">{whyUsData.heading}</h2>
        </div>

        {/* Left Features */}
        <div className="col-12 col-md-6 pt-3">

          <h1 className="fw-bold mb-4">
            Our Commitment to <br /> Quality
          </h1>

          {/* Feature Box Component Function */}
          {[
            {
              title: whyUsData.sub_heading1,
              desc: whyUsData.description1,
            },
            {
              title: whyUsData.sub_heading2,
              desc: whyUsData.description2,
            },
            {
              title: whyUsData.sub_heading3,
              desc: whyUsData.description3,
            }
          ].map((item, index) => (
            <div className="row my-4" key={index}>
              <div className="col-3">
                <div className="icon-box bg-col rounded-4 d-flex align-items-center justify-content-center">
                  <i className="bi bi-hospital text-light fs-4"></i>
                </div>
              </div>
              <div className="col-9">
                <h4 className="fw-bold">{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}

        </div>

        {/* Right Image */}
        <div className="col-12 col-md-6 pt-4 text-end">
          <img
            src={`${BASE_URL}/${whyUsData.image}`}
            alt="Why Us"
            className="img-fluid shadow"
            style={{ maxHeight: "450px", borderRadius: "12px", objectFit: "cover" }}
          />
        </div>

      </div>
    </div>
  );
}

export default Aboutwhyus1;
